module.exports = __webpack_public_path__ + "img/cardFrame_S_bd.989bc7d4.png";